import axios from 'axios';

import routes from 'app/routes';

const prepareParams = (values) => ({
  first_name: values.firstName,
  last_name: values.lastName,
  email: values.email,
  enterprise_team_id: values.team,
});

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.members.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', members: resp.data.data });
      });
  },

  update: (dispatch, memberId, values, successCallback, errorCallback) => {
    axios
      .put(routes.api.students.update(memberId), prepareParams(values))
      .then((resp) => {
        dispatch({ type: 'UPDATE', member: resp.data.data });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  delete: (dispatch, row) => {
    axios.delete(routes.api.students.destroy(row.id)).then((_resp) => {
      dispatch({
        type: 'DELETE',
        memberId: row.id,
      });
    });
  },

  deleteMulti: (dispatch, ids) => {
    axios.post(routes.api.students.multi_destroy, { ids }).then((_resp) => {
      dispatch({
        type: 'MULTI_DESTROY',
        memberIds: ids,
      });
    });
  },

  fileImport: (dispatch, enterpriseId, params, successCallback) => {
    axios
      .post(routes.api.enterprises.file_members_import(enterpriseId), { ...params })
      .then((resp) => {
        successCallback(resp.data.data);
      });
  },

  manualImport: (dispatch, enterpriseId, members, callback) => {
    axios
      .post(routes.api.enterprises.manual_members_import(enterpriseId), {
        members,
      })
      .then((resp) => {
        callback(resp.data.data);
      });
  },

  finchConnect: (code, successCallback) => {
    axios
      .post(routes.api.managers.finch.create, { code })
      .then((_response) => {
        successCallback();
      });
  },

  finchUpdate: (dispatch, params, successCallback) => {
    const parsedParams = {
      finch: {
        import_type: params.importType,
      },
    };

    axios
      .patch(routes.api.managers.finch.update, parsedParams)
      .then((_response) => {
        dispatch({ type: 'FINCH_UPDATE', params });
        successCallback();
      });
  },

  finchImport: (dispatch, teamId, membersIds, successCallback, errorCallback) => {
    axios
      .post(routes.api.managers.finch.import, { team_id: teamId, employees_ids: membersIds })
      .then((response) => {
        successCallback(response.data.data);
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  inviteMembers: (enterpriseId, memberIds, callback) => {
    axios
      .post(routes.api.enterprises.send_invite(enterpriseId), {
        students: memberIds,
        student_ids: memberIds,
      })
      .then((_resp) => {
        callback();
      });
  },

  assignMultiCpa: (programId, memberEmails, callback) => {
    axios
      .post(
        routes.api.managers.programs.assign(programId),
        {
          emails: memberEmails,
        },
      )
      .then((response) => {
        callback(response.data);
      });
  },
};
